var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.812,4.3187C10.8937,4.46094,11.027,4.56238,11.1814,4.59984L15.5468,5.65892C15.7468,5.70744,15.9079,5.8622,15.9713,6.06673C16.0348,6.27127,15.9913,6.49567,15.8567,6.65807L12.9193,10.2027C12.8154,10.3281,12.7645,10.4922,12.7782,10.6576L13.1656,15.3339C13.1834,15.5482,13.0927,15.7565,12.9266,15.8829C12.7605,16.0093,12.5433,16.0353,12.3543,15.9514L8.2283,14.1204C8.08238,14.0556,7.91762,14.0556,7.7717,14.1204L3.64575,15.9514C3.45671,16.0353,3.23953,16.0093,3.07344,15.8829C2.90734,15.7565,2.81663,15.5482,2.83438,15.3339L3.22181,10.6576C3.23551,10.4922,3.1846,10.3281,3.08071,10.2027L0.143301,6.65807C0.00871788,6.49567,-0.0347882,6.27127,0.0286541,6.06673C0.0920964,5.8622,0.25321,5.70744,0.453219,5.65892L4.81861,4.59984C4.973,4.56238,5.10629,4.46094,5.18801,4.3187L7.49854,0.296951C7.60441,0.112687,7.7947,0,8,0C8.2053,0,8.3956,0.112686,8.50146,0.296951L10.812,4.3187ZM9.55834,5.109L8,2.39652L6.44166,5.109Q5.99418,5.88789,5.14874,6.093L2.20449,6.8073L4.18563,9.198Q4.75451,9.88449,4.67948,10.7901L4.41818,13.9441L7.20094,12.7091Q8,12.3545,8.79907,12.7091L11.5818,13.9441L11.3205,10.7901Q11.2455,9.88449,11.8144,9.198L13.7955,6.8073L10.8513,6.093Q10.0058,5.88789,9.55834,5.109Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollect);
export default __webpack_public_path__ + "static/media/collect.42c3e3e7ba49ee1679b43e219b22f254.svg";
export { ForwardRef as ReactComponent };